<template>
	<ListDetailLayout
			:store="companiesStore"
      index-route-name="admin.companies"
			create-permissions="create:companies"
			@on-create="$router.push({ name: 'admin.companies.company', params: { company: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, () => refreshCompanies(false), params)"
			@on-search="(page) => useOnSearch(page, () => refreshCompanies(false), params)"
			create-button-admin-page="create-company-admin-btn"
	        search-admin-page="search-company-admin-page"
	>

		<template #list>
			<li v-for="company in companiesStore.getAllCompanies" :key="company.id">
				<router-link :to="{ name: 'admin.companies.company', params: { company: company.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
									{{ company.name }}
									
									<span>
										<IconLockCheck class="inline-block w-4 h-4 text-green-800" v-if="company.name == 'Haldex'" />
										<IconLockOff class="inline-block w-4 h-4 text-red-800" v-if="company.name != 'Haldex'" />
									</span>

								</p>
							</div>
						</div>

						<span v-if="company.vehicle_manufacturer" v-tooltip.left="$t('pages.admin.companies.companies.companies_index.this_company_is_a_manufacturer')">
							<IconBuildingFactory2 class="text-surface-500 h-6 w-6" :stroke-width="1.75"/>
						</span>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.company" @on-save="refreshCompanies(false)" @on-delete="refreshCompanies(false)"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { IconBuildingFactory2, IconLockCheck, IconLockOff } from '@tabler/icons-vue';
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "CompaniesIndex",
	data() {
		return {
			params: {}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshCompanies(silent = true){
			try {
				return this.companiesStore.indexAllCompanies(this.params, silent);
			} catch (e) {
				console.log(e);
			}
		},
	},
	components: {Container, ListDetailLayout, IconBuildingFactory2, IconLockCheck, IconLockOff},
	computed: {
		...mapStores(useCompaniesStore)
	},
	async mounted() {
		await this.refreshCompanies()
	}
}
</script>